import { AuthenticationService } from "./authentication/authentication.service";
import { Component, OnInit } from "@angular/core";
import {
    UntypedFormGroup,
    UntypedFormBuilder,
    Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { jwtDecode } from 'jwt-decode';

// import { environment } from '../../../environments/environment';
import { ToastService } from "../services/toast/toast.service";
import { ServiciosService } from "../services/servicios.service";
import { TaxisService } from "../services/taxis.service";
import { TallerService } from "../services/taller.service";
import { VehiculoTipoBusModel } from "src/app/shared/models/vehiculo/vehiculo.model";
import { SelectAppComponent } from "./select-app/select-app.component";
import { DnsModel } from "src/app/shared/models/usuarios/user.model";
import { JwtPayload } from 'src/app/shared/models/login/jwt-payload.model';
import { SubProcesosService } from "../services/sub-procesos.service";
import {
    SwitchApp,
    SwitchAppItem,
} from "src/app/shared/models/enum/switchApp.model";
import { AppComponent } from "../app.component";
import { HttpClient } from "@angular/common/http";
import { base64Decode } from "src/app/shared/utilities/utils";
import { PoliticaPrivacidadComponent } from "./politica-privacidad/politica-privacidad.component";
import { getAppVersion } from "src/app/shared/constants/app-version";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})


export class LoginComponent implements OnInit {
    //form
    form: UntypedFormGroup;

    //boolean
    loading: boolean;
    validar: boolean;

    //strings

    get version(): string {
        return getAppVersion();
    }
    routeConduct: string = "conductores/listado-servicios";
    routeTaxis: string = "taxis/form";
    tokenTrafico: string;
    tokenTaller: string;
    passUser: string;
    loginUser: string;
    constructor(
        public app: AppComponent,
        private fb: UntypedFormBuilder,
        private router: Router,
        private msg: ToastService,
        private auth: AuthenticationService,
        private serviciosService: ServiciosService,
        private tallerService: TallerService,
        private taxisService: TaxisService,
        private sPro: SubProcesosService,
        private http: HttpClient
    ) {
        if (this.auth.currentUserValue) {
            this.router.navigate([
                this.auth.currentUserValue.codempleado
                    ? this.routeConduct
                    : this.routeTaxis,
            ]);
        }
    }

    async ngOnInit() {
        this.loading = true;
        // await this.autoAutenticaticate();
        this.form = this.getForm();

        // se comprueba si hay dns registradas
        await this.getDatosGuardados();
    }

    async submit() {
        if (this.loading) {
            return;
        }

        this.validar = true;
        this.msg.clear();
        if (this.form.invalid) {
            this.msg.showWarn("No has rellenado los campos necesarios.");
            return;
        }
        this.validar = false;
        this.loading = true;
        this.form.get("empresa").setValue(this.changeNy().toLowerCase());
        this.auth.setDns(this.form.value.empresa);

        var conductLogin, vehiTaxi;
        var errConduct, errTaxi;
        var continueLoggin = true;

        let user = {
            tokenTrafico: null,
            tokenTaller: null,
            activeVehicle: [],
        };

        await this.serviciosService
            .loginTrafico(this.form.value.login, this.form.value.password)
            .toPromise()
            .then(
                (res) => {
                    this.tokenTrafico = res.token;
                    user.tokenTrafico = res.token;
                },
                () => {
                    continueLoggin = false;
                }
            );

        await this.tallerService
            .loginTaller(this.form.value.login, this.form.value.password)
            .toPromise()
            .then(
                (res) => {
                    this.tokenTaller = res.token;
                    user.tokenTaller = res.token;
                },
                () => {
                    continueLoggin = false;
                }
            );

        // Cuando tengas ambos tokens (o los que consigas)
        console.log("user:", user);
        this.auth.guardarCurrentUser(user);

        console.log("TokenTrafico:" + this.tokenTrafico);
        console.log("TokenTaller:" + this.tokenTaller);

        if (!continueLoggin) {
            console.log("continueLoggin");
            this.msg.showError("Error de credenciales, revise sus datos de acceso. Si el error persiste póngase en contacto con el departamento de Recursos Humanos.", 15000);
            this.loading = false;
            return;
        }

        await this.serviciosService
            .getServiciosEmpleado(new Date())
            .toPromise()
            .then(
                (res) => {
                    conductLogin = res;
                },
                (err) => {
                    console.log(err);
                    errConduct = err;
                }
            );

        await this.taxisService
            .loggin(this.form.value.login, this.form.value.password)
            .toPromise()
            .then(
                (res) => {
                    console.log(res);
                    var obje = atob(res);
                    var reps =
                        obje == null || obje == "null"
                            ? null
                            : JSON.parse(obje);

                    if (reps != null) {
                        vehiTaxi = reps;
                    } else {
                        errTaxi = true;
                    }
                },
                (err) => {
                    console.log(err);
                    errTaxi = err;
                }
            );

        console.log("vehiTaxi:" + vehiTaxi);
        console.log("errTaxi:" + errTaxi);

        if (!continueLoggin) {
            console.log("continueLoggin2");
            return;
        }

        if (conductLogin || vehiTaxi) {
            console.log("checkIfAppConductoresAndAppTaxis");
            this.checkIfAppConductoresAndAppTaxis(conductLogin, vehiTaxi);
            return;
        }

        this.loading = false;
        if (errConduct || errTaxi) {
            console.log("errorLogin");
            this.errorLogin();
        }
    }

    changeNy() {
        var empreewrong = this.form.controls["empresa"].value as string;
        empreewrong = empreewrong.replace("ñ", "ny");
        empreewrong = empreewrong.replace("Ñ", "NY");

        return empreewrong;
    }

    checkIfAppConductoresAndAppTaxis(lConduct, lTaxis: VehiculoTipoBusModel) {
        console.log("checkIfAppConductoresAndAppTaxis");
        if (lConduct && lTaxis) {
            var ref = this.msg.open(SelectAppComponent, {
                width: "100%",
                closable: false,
                styleClass: "custom-confirm",
                data: {
                    loginConductores: () =>
                        this.setLogin(lConduct, lTaxis, SwitchApp.CONDUCTORES),
                    loginTaxi: () =>
                        this.setLogin(lConduct, lTaxis, SwitchApp.TAXIS),
                },
            });
            ref.onClose.subscribe((res) => {
                if (res) {
                    res();
                }
            });
            return;
        }

        if (lConduct) {
            this.setAuth(this.setLoginConduct(lConduct), SwitchApp.CONDUCTORES);
            return;
        }

        if (lTaxis) {
            this.setAuth(this.setLoginTaxis(lTaxis), SwitchApp.TAXIS);
            return;
        }

        this.errorLogin();
    }

    setLogin(lConduct, lTaxis, menu: SwitchAppItem) {
        var authConduct, authTaxi;
        if (lConduct) {
            authConduct = this.setLoginConduct(lConduct);
        }
        if (lTaxis) {
            authTaxi = this.setLoginTaxis(lTaxis);
        }
        this.setAuth({ ...authConduct, ...authTaxi }, menu);
    }

    setMenu(menu: SwitchAppItem) {
        this.app.changeSwitchApp(menu);
    }

    setLoginConduct(login) {
        if (login) {
            if (this.sPro.getDeviceId() != null) {
                this.taxisService
                    .setDatosGuardadosTaller()
                    .toPromise()
                    .then(
                        (res) => { },
                        () => {
                            console.log("Guardado de datos Appc API");

                        }
                    );
                this.taxisService
                    .setDatosGuardadosTrafico()
                    .toPromise()
                    .then(
                        (res) => { },
                        () => {
                            console.log("Guardado de datos Appc API");
                        }
                    );
            }

            return {
                tokenTrafico: this.tokenTrafico,
                basicauth: btoa(
                    `${this.form.value.login}:${this.form.value.password}`
                ),
                codempleado: login[0].codemple,
                nomusu: login[0].nomemple,
                numempre: login[0].numempre,
                activeVehicle: [],
                // dni: login.Conductor ? login.Conductor.split("DNI: ")[1] : null,
                dni: login[0].dni,
            };
        }
    }



    setLoginTaxis(login: VehiculoTipoBusModel) {
        if (this.sPro.getDeviceId() != null) {
            this.taxisService
                .setDatosGuardadosTaller()
                .toPromise()
                .then(
                    (res) => { },
                    () => {
                        console.log("Guardado de datos AppT API");
                        // this.msg.showError(
                        //     "Error al guardar los datos en la caché."
                        // );
                    }
                );
            this.taxisService
                .setDatosGuardadosTrafico()
                .toPromise()
                .then(
                    (res) => { },
                    () => {
                        console.log("Guardado de datos AppT API");
                        // this.msg.showError(
                        //     "Error al guardar los datos en la caché."
                        // );
                    }
                );
        }

        return {
            tokenTrafico: this.tokenTrafico,
            loginTaxis: {
                vehiculo: login,
                matricula: login.matricul,
            },
            activeVehicle: [],
        };
    }

    setAuth(user, menu: SwitchAppItem) {
        this.auth.guardarCurrentUser(user);
        this.setMenu(menu);
        this.router.navigate([menu.iniroute]);
        if (this.app.tokenOS && menu === SwitchApp.CONDUCTORES) {
            this.updateTokenPush();
        }
    }

    updateTokenPush() {
        try {
            this.serviciosService.updateTokenPush(this.app.tokenOS).toPromise();
        } catch (err) {
            console.error("ERROR UPDATE TOKEN PUSH", err);
        }
    }

    errorLogin() {
        this.loading = false;
        this.msg.showError("Error en el login.");
    }


    async getDatosGuardados() {

        await new Promise(resolve => setTimeout(resolve, 1000));

        console.log("Iniciando getDatosGuardados...");
        this.msg.clear();

        this.loading = true;

        let resTrafico, resTaller;
        var continueLoggin = true;


        try {
            resTrafico = await this.serviciosService.loginDeviceTrafico().toPromise();
        } catch (err) {
            console.error("ERROR FATAL en Paso 1 (loginDeviceTrafico):", err);
            this.loading = false;
            continueLoggin = false;
            return;
        }

        try {
            resTaller = await this.serviciosService.loginDeviceTaller().toPromise();
        } catch (err) {
            console.error("ERROR FATAL en Paso 2 (loginDeviceTaller):", err);
            this.loading = false;
            continueLoggin = false;
            return;
        }

        if (!continueLoggin) {
            console.log("continueLoggin");
            return;
        }


        let user = {
            tokenTrafico: resTrafico.token,
            tokenTaller: resTaller.token,
            activeVehicle: []
        };

        this.tokenTaller = resTaller.token;
        this.tokenTrafico = resTrafico.token;

        this.auth.setDns(resTrafico.tenant || resTaller.tenant);

        console.log("Datos de usuario");
        console.log(user);
        this.auth.guardarCurrentUser(user);

        const payload: JwtPayload = jwtDecode<JwtPayload>(this.tokenTrafico);

        try {
            userVehicle = await this.serviciosService.getCredencialesVehiculo(payload.Name, payload.Login).toPromise();
        } catch (err) {
            console.error("ERROR FATAL en Paso 1 (loginDeviceTrafico):", err);
            this.loading = false;
            continueLoggin = false;
            return;
        }

        var conductLogin, vehiTaxi, loginTaxis, userVehicle;
        try {
            conductLogin = await this.serviciosService.getServiciosEmpleado(new Date()).toPromise();
        } catch (err) {
            console.error("ERROR FATAL en Paso 1 (loginDeviceTrafico):", err);
            this.loading = false;
            continueLoggin = false;
        }

        try {
            loginTaxis = await this.taxisService.loggin(userVehicle.result.login, userVehicle.result.password).toPromise();
        } catch (err) {
            console.error("ERROR FATAL en Paso 1 (loginDeviceTrafico):", err);
            this.loading = false;
            continueLoggin = false;
        }

        console.log("Datos obtenidos:");
        console.log("payload:", payload);
        console.log("loginTaxis:", loginTaxis);
        console.log("conductLogin:", conductLogin);

        var obje = atob(loginTaxis);
        var reps = obje == null || obje == "null" ? null : JSON.parse(obje);
        vehiTaxi = null;
        if (reps != null) {
            vehiTaxi = reps;
        }

        if (conductLogin || vehiTaxi) {
            console.log("checkIfAppConductoresAndAppTaxis");
            this.checkIfAppConductoresAndAppTaxis(conductLogin, vehiTaxi);
            return;

        } else {
            this.errorLogin();
        }


        this.loading = false;

    }

    chooseSetDns(dnsConductores, dnsTaxis) {
        if (dnsConductores && dnsTaxis) {
            this.msg.showConfirmation({
                header: "Credenciales detectadas",
                message: "¿Que credenciales quieres cargar?",
                accept: () => this.setLoginDns(dnsConductores),
                acceptLabel: "Conductores",
                acceptButtonStyleClass: "p-button-danger",
                reject: () => this.setLoginDns(dnsTaxis),
                rejectLabel: "Taxis",
            });
            return;
        }

        this.setLoginDns(dnsConductores ?? dnsTaxis);
    }

    setLoginDns(dns: DnsModel) {
        if (dns) {
            this.form.get("empresa").setValue(base64Decode(dns.empresa));
            this.form.get("login").setValue(base64Decode(dns.login));
            this.form.get("password").setValue(base64Decode(dns.password));
        }
    }

    buildDns(app: number) {
        return new DnsModel(
            this.sPro.getDeviceId(),
            this.form.value.login,
            this.form.value.password,
            this.form.value.empresa,
            app
        );
    }

    //#endregion

    //#region form

    getForm() {
        return this.fb.group({
            empresa: [null, Validators.required],
            login: [null, Validators.required],
            password: [null, Validators.required],
        });
    }

    get f() {
        return this.form.controls;
    }
    //#endregion

    openPoliticaPrivacidad() {
        this.msg.open(PoliticaPrivacidadComponent, {
            header: "RGPD - APP Conductores",
        });
    }
}
